import { createSelector } from 'reselect'
import * as R from 'ramda'

import {
  FORM_STATUS
} from 'containers/Project/constants'
import {
  formStatusSelector,
} from 'containers/Project/selectors'

const redirectSelector = state => state.projectOverview.redirect
const isCreateSelector = createSelector(
  formStatusSelector,
  R.anyPass([
    R.equals(FORM_STATUS.CLONE),
    R.equals(FORM_STATUS.CREATE),
    R.equals(FORM_STATUS.UPDATE),
    R.equals(FORM_STATUS.REVIEW),
    R.equals(FORM_STATUS.VIEW)
  ])
)

export {
  redirectSelector,
  isCreateSelector
}
